import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import client, { endpoints } from '../api/client';

export default function AskQuestion() {
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', body: '', tags: '' });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  if (!user) return <div className="container community narrow"><h1>Ask a question</h1><p className="muted"><Link to="/login">Sign in</Link> to ask a question.</p></div>;

  async function submit(e) {
    e.preventDefault(); setErr(null);
    try { const { data } = await client.post(endpoints.questions.create, form); navigate(`/questions/${data.slug}`); }
    catch (e) { setErr(e?.response?.data?.error || 'Failed'); }
  }
  return (
    <div className="container community narrow">
      <h1>Ask a public question</h1>
      <form onSubmit={submit} className="form">
        <label>Title<input value={form.title} onChange={set('title')} placeholder="e.g. How do I configure X for Y?" required /></label>
        <label>Body<textarea rows={10} value={form.body} onChange={set('body')} placeholder="Describe the problem in detail…" required /></label>
        <label>Tags (comma-separated)<input value={form.tags} onChange={set('tags')} placeholder="tag1, tag2" /></label>
        <button className="btn-primary">Post your question</button>
        {err && <p className="err">{err}</p>}
      </form>
    </div>
  );
}
